import { useState, useEffect } from 'react';
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { BpmService } from "../../../core/services/BpmService";
import { ListMenu } from "../../theme/Component/ListMenu";
import { FileInput } from "../../theme/Component/FileInput";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import { JsonFormaterInput } from '../../theme/Component/JsonFormaterInput';
import { PrintJson } from '../../theme/Component/PrintJson';
import { MultipleFileInput } from '../../theme/Component/MultipleFileInput';

interface Props {
    appName?: string;
}

export const SystemPropertie = ({ appName }: Props) => {

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    const idBean = 'IDSystemProperty';

    useEffect(() => {
        getLista();
    }, [])

    const setRowBean = (bean: any) => {
        setBean(bean);
    }

    const getLista = () => {
        setLoading(true);
        if (appName) {
            service.getSystemPropertyByAppName(appName).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ObjectValue) {
                        setLista(resp.DataBeanProperties.ObjectValue);
                    }
                    setLoading(false);
                }
            );

        } else {

            service.getSystemPropertyList(null).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ObjectValue) {
                        setLista(resp.DataBeanProperties.ObjectValue);
                    }
                    setLoading(false);
                }
            );
        }
    }

    const agregarItem = () => {

        let b = {
            Name: '',
            Since: single.getCurrenDate(),
            Description: '',
            SystemValue: '',
            AppName: appName ?? '',
        }
        setBean(b);
        setModal({ ...modal, ['view']: true });
    }

    const editarItem = () => {
        setModal({ ...modal, ['view']: true });
    }

    const eliminarItem = () => {

        setLoading(true);
        service.deleteSystemProperty(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
            }
        );
        setModalConfirm({ ...modalConfirm, ['view']: false });
    }

    const updateItem = () => {
        setModal({ ...modal, ['view']: false });
        setLoading(true);
        service.updateSystemProperty(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
            });
    }

    const head = [
        { title: 'ID', property: idBean },
        { title: 'Nombre', property: 'Name' },
        { title: 'Descripción', property: 'Description' },
        { title: 'AppName', property: 'AppName' },
        { title: 'SystemValue', property: 'SystemValue' },

    ]

    const renderButton = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <BasicButton value="Agregar" icon="ri-file-add-line" eventClick={agregarItem} ></BasicButton>
                        {bean[idBean] &&
                            <>
                                <BasicButton value="Editar" icon="ri-edit-2-line" eventClick={editarItem} ></BasicButton>
                                <BasicButton value="Eliminar" icon="ri-eraser-line" eventClick={() => { setModalConfirm({ ...modalConfirm, ['view']: true }); }} ></BasicButton>
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [

        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }

    ]


    return (
        <>
            {appName ?
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />
                </div>
                :
                <BasicPage titulo="Propiedades del sistema">
                    <div className="row">
                        <div className="col-md-12">
                            <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />
                        </div>
                    </div>
                </BasicPage>

            }

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Nombre</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, ['Name']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">AppName</label>
                        <input disabled={appName != undefined} type="text" className="form-control" value={bean.AppName} onChange={(e) => { setBean({ ...bean, ['AppName']: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-6">
                        <label>Tipo Campo</label>
                        <select name="tipo" className='form-select' value={bean.Type} onChange={(e) => { setBean({ ...bean, ['Type']: parseInt(e.target.value) }) }}>
                            <option value={1}>NUMERO</option>
                            <option value={2}>TEXTO</option>
                            <option value={3}>JSON</option>
                        </select>
                    </div>

                    <div className="col-md-12">
                        {bean.Type === 3 ?
                            <>
                                <JsonFormaterInput inputType='string' returnType='string' _label='System Value' value={bean.SystemValue} onChange={(e) => { setBean({ ...bean, SystemValue: e }) }} />
                            </>
                            :
                            <>
                                <label className="form-label">System Value</label>
                                <input className='form-control' type="text" value={bean.SystemValue} onChange={(e) => { setBean({ ...bean, ['SystemValue']: e.target.value }) }} />
                            </>
                        }
                    </div>
                </div>
                <MultipleFileInput directory='temp' onCreate={(e) => {
                    console.log(e);
                }} />
                {/* <FileInput onCreate={({ Media, MediaContext }: any) => {
                    let temp = {
                        Media: Media,
                        MediaContext: MediaContext
                    }                    
                }}></FileInput> */}
            </Modal>
        </>
    )
}